// Math[@@toStringTag] property
// https://tc39.github.io/ecma262/#sec-math-@@tostringtag
require('../internals/set-to-string-tag')(Math, 'Math', true);
